import AutomationApplicationsTable from "@components/automations/AutomationApplicationsTable";
import ExpertTablesPage from "@components/pageTypes/ExpertTablesPage";
import PageTitle from "@components/text/PageTitle";

type Props = {
  automationId: string;
};

const ExpertAutomationApplicationsPage = ({ automationId }: Props) => (
  <ExpertTablesPage helmetKey="pageTitles.expert.automationApplication.list">
    <PageTitle imageName="womanPlan" titleKey="pages.expert.automations.title" />
    <AutomationApplicationsTable automationId={automationId} />
  </ExpertTablesPage>
);

export default ExpertAutomationApplicationsPage;
